import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogProps,
  IconButton,
  Box,
  Typography
} from '@mui/material';
import { FiX } from 'react-icons/fi';

interface CustomDialogProps extends Omit<DialogProps, 'title'> {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  title,
  onClose,
  children,
  ...dialogProps
}) => {
  return (
    <Dialog {...dialogProps} onClose={onClose}>
      {title && (
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={onClose} size="small">
              <FiX />
            </IconButton>
          </Box>
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}; 